import React, { useState, useRef } from 'react'

import ReCAPTCHA from 'react-google-recaptcha'

import { recaptchaKey } from 'script-params'

export const useRecaptcha = () => {
  const recaptchaRef = useRef()
  const [error, setError] = useState(null)
  const isDisabled = !recaptchaKey
  return {
    error,
    renderBadge: () => {
      if (isDisabled) {
        return null
      }
      return (
        <ReCAPTCHA
          ref={recaptchaRef}
          size="normal"
          sitekey={recaptchaKey}
          onErrored={(err) => setError(err)}
        />
      )
    },
    getToken: () => {
      return recaptchaRef.current?.getValue?.()
    },
    // only used with invisible
    getTokenAsync: async () => {
      if (isDisabled) {
        return undefined
      }
      try {
        return await recaptchaRef.current.executeAsync()
      } catch (err) {
        // setError(err)
        console.log(err)
        throw err
      }
    },
  }
}
